import SmallScreenHeader from "../../../../../components/SmallScreenHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  showFilterOverlay,
  showSortOverlay
} from "../../../../../state/modules/layout/actions";
import { hasSelectedFacets } from "../../../../../state/modules/search/selectors";
import { withTranslation } from "../../../../../components/translation/";

const ConnectedSmallScreenHeader = props => {
  const dispatch = useDispatch();

  return (
    <SmallScreenHeader
      hasSelectedFacets={useSelector(hasSelectedFacets)}
      showFilterOverlay={() => dispatch(showFilterOverlay())}
      showSortOverlay={() => dispatch(showSortOverlay())}
      {...props}
    />
  );
};

export default withTranslation(ConnectedSmallScreenHeader);
